import React, { useState, useEffect } from "react";
import MainTabs from "../partials/main-tabs.jsx";
import LetteredAvatar from "react-lettered-avatar";
import { viewRecord } from "../../firebase/db/users/crud.tsx";
import { useAuth } from "../../contexts/authContext/index.jsx";
import ImageUploadModal from "../partials/form-modals/profile/image-upload-modal.tsx";
import { useNavigate } from "react-router-dom";

interface DataType {
	first_name?: string;
	last_name?: string;
	artist_name?: string;
	is_active?: Boolean;
	email?: string;
	created?: string;
	modified?: string;
	profile_url?: string;
}

const Profile = () => {
	const navigate = useNavigate();
	const { currentUser } = useAuth();
	const [data, setData] = useState<DataType>({
		id: "",
		first_name: "",
		last_name: "",
		artist_name: "",
		email: "",
		created: "",
		modified: "",
		profile_url: ""
	});
	const [isModalOpen, setModalOpen] = useState(false);

	useEffect(() => {
		const fetchDataAndSetState = async () => {
			try {
				console.log("Fetching data...");
				const fetchedData = await viewRecord(currentUser.uid);
				if (fetchedData !== null) {
					setData(fetchedData);
				} else {
					setData({ id: "", first_name: "", last_name: "", artist_name: "", created: "", modified: "" }); //Set default values
				}
			} catch (e) {
				// setError(e); //More informative error message
			} finally {
				// setIsLoading(false);
			}
		};

		fetchDataAndSetState();
	}, [currentUser.uid]);

	return (
		<div>
			<div class="main-tabs">
				<div class="mx-auto">
					<MainTabs tabIndexSelected={null} />
					<div id="myTabContent">
						<div className="grid grid-cols-4 gap-5 mt-6">
							<div
								className="height-auto col-span-4 shadow-xl bg-slate-500 py-4 px-5 rounded-lg"
								id="profile"
								role="tabpanel"
								aria-labelledby="profile-tab">
								<div className="mb-2 flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4">
									<div>
										<h2 className="text-3xl font-medium">Profile</h2>
									</div>
									<div className="relative">
										<div className="inline-flex rounded-md shadow-xs" role="group">
											<button
												// onClick={() => navigate(`/home/edit/${id}`)}
												type="button"
												className="px-4 py-2 text-sm font-light text-gray-900 bg-white border border-r-0 border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
												Edit
											</button>
											<button
												onClick={() => navigate(`/home`)}
												type="button"
												className="px-4 py-2 text-sm font-light text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
												Close
											</button>
										</div>
									</div>
								</div>
								<form className="">
									<div className="flex gap-8">
										<div className="flex-auto">
											<div className="grid md:grid-cols-2 md:gap-6">
												<div className="col-span-2">
													<button type="button" onClick={() => setModalOpen(true)}>
														{data.profile_url ? (
															<img className="w-32 h-32 rounded-full" src={data.profile_url} alt={data.artist_name} />
														) : (
															<LetteredAvatar size={200} radius={20} name={data.artist_name} />
														)}
													</button>
												</div>
												<div className="relative z-0 w-full mb-5 group">
													<input
														type="text"
														name="artist_name"
														id="artist_name"
														value={data.artist_name}
														className="block py-2.5 px-0 w-full text-medium text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
														placeholder=" "
														// disabled
													/>
													<label
														for="internal_song_name"
														className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-800 font-medium duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
														Artist Name
													</label>
												</div>
												<div className="relative z-0 w-full mb-5 group">
													<input
														type="text"
														name="email"
														id="email"
														className="block py-2.5 px-0 w-full text-medium text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
														placeholder=" "
														value={data.email}
														disabled
													/>
													<label
														for="song_name"
														className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-800 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
														Email
													</label>
												</div>
											</div>
											<div className="grid md:grid-cols-2 md:gap-6">
												<div className="relative z-0 w-full mb-5 group">
													<input
														type="text"
														name="bpm"
														id="bpm"
														className="block py-2.5 px-0 w-full text-medium text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
														placeholder=" "
														// value={data.bpm}
														disabled
													/>
													<label
														for="bpm"
														className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-800 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
														BPM
													</label>
												</div>
												<div className="relative z-0 w-full mb-5 group">
													<input
														type="text"
														name="key"
														id="key"
														className="block py-2.5 px-0 w-full text-medium text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
														placeholder=" "
														// value={data.key}
														disabled
													/>
													<label
														for="key"
														className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-800 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
														Key
													</label>
												</div>
											</div>
											<div className="grid md:grid-cols-1 md:gap-6">
												<div className="relative z-0 w-full mb-5 group">
													<input
														type="text"
														name="description"
														id="description"
														className="block py-2.5 px-0 w-full text-medium text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
														placeholder=" "
														// value={data.description}
														disabled
													/>
													<label
														for="description"
														className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-800 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
														Description
													</label>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ImageUploadModal userUID={currentUser.Id} isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
		</div>
	);
};

export default Profile;
